import React, { createRef } from 'react';
import styles from './LoginScreenComponent.module.scss';
import { RouteComponentProps } from 'react-router';
import { LoginScreenProps } from './LoginScreen';
import classNames from 'classnames';
import LoginForm from './login-form/LoginForm';
import { PATH_ROOT, PATH_SIGN_IN } from '../../../constants/routerPaths';
import toast from 'fulogics-ui-web/dist/utils/toast';

interface LoginScreenComponentState {}

export default class LoginScreenComponent extends React.Component<
    LoginScreenComponentProps,
    LoginScreenComponentState
> {
    constructor(props: LoginScreenComponentProps) {
        super(props);
        //
        this.state = {};
    }

    componentDidUpdate(
        prevProps: Readonly<LoginScreenComponentProps>,
        prevState: Readonly<LoginScreenComponentState>,
        snapshot?: any
    ) {
        const { isLogged, history, location } = this.props;

        if (isLogged) {
            location.pathname !== PATH_SIGN_IN ? window.location.reload() : history.push(PATH_ROOT);
        }
    }

    render() {
        const login = async (username: string, password: string) => {
            //
            return this.props.login?.(username, password)?.catch((error) => {
                toast.exception(error, 'Cannot login.');
            });
        };

        return (
            <div className={styles.container}>
                <div className={classNames(styles.item, styles.login)}>
                    <div className={styles.loginForm}>
                        <LoginForm login={login} />
                    </div>
                </div>
                <div className={classNames(styles.item, styles.itemImage)} />
            </div>
        );
    }
}

type LoginScreenComponentProps = LoginScreenProps & RouteComponentProps<{}>;
